import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import CrehanaForBusiness from "@crehana/icons/logos/CrehanaForBusiness";
import clsx from "clsx";
const OrganizationLogoImage = ({ src, alt, colors, className, customSizeLogo })=>{
    const [loaded, setLoaded] = useState(false);
    const [is404Image, setIs404Image] = useState(false);
    const style = loaded ? {
        maxHeight: '32px',
        maxWidth: '128px'
    } : {
        width: 128,
        height: 32
    };
    const handleImageError = ()=>setIs404Image(true);
    if (is404Image) return /*#__PURE__*/ jsx(CrehanaForBusiness, {
        size: 32,
        "aria-hidden": true,
        color: colors?.primary,
        secondaryColor: colors?.secondary,
        className: className
    });
    return /*#__PURE__*/ jsx("img", {
        src: src,
        alt: alt,
        "aria-hidden": true,
        onLoad: ()=>{
            setLoaded(true);
        },
        style: customSizeLogo ? {
            ...style
        } : style,
        className: clsx(!customSizeLogo && 'h-24', className),
        onError: handleImageError
    });
};
const components_OrganizationLogoImage = OrganizationLogoImage;
export default components_OrganizationLogoImage;
